// action
import {
  GET_ARTICLE_TAGS,
  GET_ARTICLE_TAGS_FAIL,
  GET_ARTICLE_TAGS_SUCCESS,
  GET_ARTICLE_TAGS_RESET,
} from "../action/getArticleTagsAction";
import { api_err_msg } from "../strings.json";

// initialState
const initialState = {
  apiState: "",
  list: [],
  message: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ARTICLE_TAGS:
      return {
        ...state,
        apiState: "loading",
      };
    case GET_ARTICLE_TAGS_FAIL:
      return {
        ...state,
        apiState: "error",
        message:
          (action.response &&
            action.response.data &&
            action.response.data.message) ||
          api_err_msg,
      };
    case GET_ARTICLE_TAGS_SUCCESS:
      return {
        ...state,
        apiState: "success",
        list: action.response.data.data.result,
      };
    case GET_ARTICLE_TAGS_RESET:
      return initialState;
    default:
      return state;
  }
}
